import type { Persona } from "./persona-store";

/**
 * Mock vocabulary for each persona lens. Every demo, the hero diorama and
 * the day narrative draw names from here so the whole page speaks the
 * visitor's language. All data is fictional.
 */
export interface PersonaContent {
  /** Chip label, e.g. "a tuition centre". */
  chipLabel: string;
  orgName: string;
  studentName: string;
  parentName: string;
  batchName: string;
  secondBatchName: string;
  monthlyFee: number;
  branchNames: [string, string];
}

export const PERSONA_CONTENT: Record<Persona, PersonaContent> = {
  "tuition-centre": {
    chipLabel: "a tuition centre",
    orgName: "Sunrise Tuition Centre",
    studentName: "Aarav S.",
    parentName: "Mrs Nair",
    batchName: "Std 10 Maths — Evening",
    secondBatchName: "Std 9 Science — Morning",
    monthlyFee: 1500,
    branchNames: ["Main Road", "Lakeside"],
  },
  "coaching-institute": {
    chipLabel: "a coaching institute",
    orgName: "Apex Coaching Institute",
    studentName: "Diya M.",
    parentName: "Mr Menon",
    batchName: "NEET Biology — Morning",
    secondBatchName: "JEE Maths — Evening",
    monthlyFee: 3500,
    branchNames: ["City Centre", "College Road"],
  },
  "music-dance-academy": {
    chipLabel: "a music & dance academy",
    orgName: "Tarang Academy of Music & Dance",
    studentName: "Ishaan R.",
    parentName: "Mrs Pillai",
    batchName: "Hindustani Vocal — Evening",
    secondBatchName: "Bharatanatyam — Weekend",
    monthlyFee: 1800,
    branchNames: ["Temple Road", "New Town"],
  },
  "multi-branch": {
    chipLabel: "a multi-branch network",
    orgName: "Crescent Learning Centres",
    studentName: "Fatima K.",
    parentName: "Mr Rahman",
    batchName: "Std 12 Physics — Weekend",
    secondBatchName: "Std 11 Chemistry — Evening",
    monthlyFee: 2200,
    branchNames: ["North Campus", "South Campus"],
  },
};
